export { SomethingWentWrongDS } from './something-went-wrong-ds'
export type { SomethingWentWrongDSProps } from './something-went-wrong-ds.types'
